import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=3b1af48f&"
import script from "./Stock.vue?vue&type=script&lang=js&"
export * from "./Stock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Stock.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardTitle,
  VContainer,
  VFlex,
  VTextField,
})
